import React from 'react';
import { Button, Box } from '@mui/material';

const ActionButton = ({ onClick, color, hovercolor, label, disabled = false, icon,variant="contained" }) => {
    return (
        <Box sx={{ justifyContent: "center", display: "flex", alignItems: "center", mt: 3 }}>
            <Button
                variant={variant}
                onClick={onClick}
                sx={{
                    backgroundColor: color, // Dynamically set the color
                    padding: "10px 80px",
                    fontSize: { xs: "12px", sm: "14px", md: "16px" }, // Responsive font size
                    fontWeight: 600,
                    textTransform: "none",
                    "&:hover": { backgroundColor: hovercolor },
                    opacity: disabled ? 0.5 : 1,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    width: { xs: "100%", sm: "auto" },

                }}
                disabled={disabled}
            >
                {icon && (
                    icon
                )} {label}
            </Button>
        </Box>
    );
};

export default ActionButton;